import { useState, useEffect } from 'react';
import { useApi } from '../hooks/useApi';

export default function GruposRrpp() {
  const api = useApi();
  const [groups, setGroups] = useState([]);
  const [users, setUsers] = useState([]);
  const [newName, setNewName] = useState('');

  const load = () => {
    api.get('/api/groups').then(setGroups).catch(() => {});
    api.get('/api/users').then(setUsers).catch(() => {});
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  async function createGroup() {
    if (!newName.trim()) return;
    try { await api.post('/api/groups', { name: newName }); setNewName(''); load(); }
    catch (e) { alert(e.message); }
  }

  return (
    <div className="lb-fade">
      <div style={{ marginBottom: 6 }}><div className="lb-display" style={{ fontSize: 24 }}>Equipos predefinidos</div></div>
      <p style={{ color: 'var(--ink-700)', fontSize: 14, marginTop: 0, marginBottom: 24 }}>Armá equipos de RRPP una vez y reutilizalos al crear eventos.</p>

      <div style={{ display: 'flex', gap: 10, marginBottom: 24, maxWidth: 460 }}>
        <input className="lb-input" value={newName} onChange={e => setNewName(e.target.value)} placeholder="Nombre del nuevo equipo" onKeyDown={e => e.key === 'Enter' && createGroup()} />
        <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={createGroup}>+ Crear grupo</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: 20 }}>
        {groups.map(g => <GroupCard key={g.id} group={g} users={users} api={api} reload={load} />)}
        {groups.length === 0 && <div style={{ color: 'var(--ink-600)', fontSize: 13 }}>Todavía no hay equipos. Creá el primero.</div>}
      </div>
    </div>
  );
}

function GroupCard({ group, users, api, reload }) {
  const [members, setMembers] = useState(group.members || []);
  const [adding, setAdding] = useState(false);
  const [creating, setCreating] = useState(false);
  const [cf, setCf] = useState({ email: '', role: 'socio' });
  const [inviteMsg, setInviteMsg] = useState('');
  const [dirty, setDirty] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => { setMembers(group.members || []); }, [group]);

  const memberUserIds = new Set(members.map(m => m.user_id));
  const assignable = users.filter(u => !memberUserIds.has(u.id) && u.role !== 'owner');

  const setRole = (memberId, role) => { setMembers(ms => ms.map(m => m.id === memberId ? { ...m, role } : m)); setDirty(true); };

  async function addMember(userId) {
    try { await api.post(`/api/groups/${group.id}/members`, { user_id: userId, role_label: 'rrpp' }); setAdding(false); reload(); }
    catch (e) { alert(e.message); }
  }
  async function removeMember(memberId) {
    try { await api.del(`/api/groups/${group.id}/members/${memberId}`); reload(); } catch (e) { alert(e.message); }
  }
  async function invite() {
    if (!cf.email.trim()) { alert('Ingresá el email'); return; }
    setInviteMsg('');
    try {
      const r = await api.post('/api/users/invite', { email: cf.email, role: cf.role, group_id: group.id });
      if (r.sent) { setInviteMsg('Invitación enviada ✓'); }
      else if (r.invite_url) { setInviteMsg('Link (dev): ' + r.invite_url); }
      else { setInviteMsg('Invitación creada'); }
      setCf({ email: '', role: 'socio' });
      reload();
      setTimeout(() => { setInviteMsg(''); setCreating(false); }, r.invite_url ? 12000 : 2500);
    } catch (e) { alert(e.message); }
  }
  async function deleteGroup() {
    if (!window.confirm(`¿Eliminar el equipo ${group.name}?`)) return;
    try { await api.del(`/api/groups/${group.id}`); reload(); } catch (e) { alert(e.message); }
  }
  async function save() {
    try {
      await Promise.all(members.map(m => api.patch(`/api/users/${m.user_id}`, { role: m.role })));
      setDirty(false); setSaved(true); setTimeout(() => setSaved(false), 2000); reload();
    } catch (e) { alert(e.message); }
  }

  return (
    <div className="lb-card" style={{ padding: '20px 22px' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div>
          <div className="lb-h" style={{ fontSize: 17 }}>{group.name}</div>
          <div style={{ fontSize: 11, color: 'var(--ink-600)', marginTop: 2 }}>{members.length} RRPP</div>
        </div>
        <button className="lb-iconbtn" onClick={deleteGroup} title="Eliminar equipo">✕</button>
      </div>

      <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {members.map(m => (
          <div key={m.id} style={{ display: 'grid', gridTemplateColumns: '1fr auto auto', gap: 10, alignItems: 'center', padding: '8px 0', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ color: '#fff', fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {m.profile_complete === false ? m.email : (m.full_name || m.name)}
                {m.profile_complete === false && <span className="lb-status lb-status--gen" style={{ marginLeft: 8 }}>Pendiente</span>}
              </div>
              <div style={{ fontSize: 11, color: 'var(--ink-600)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{m.email}</div>
            </div>
            <select className="lb-select" style={{ padding: '6px 28px 6px 10px', fontSize: 12, width: 140 }} value={['owner', 'admin', 'socio', 'rrpp'].includes(m.role) ? m.role : 'rrpp'} onChange={e => setRole(m.id, e.target.value)}>
              <option value="owner">Dueño</option>
              <option value="socio">Socio</option>
              <option value="admin">Administrador</option>
              <option value="rrpp">RRPP</option>
            </select>
            <button className="lb-iconbtn" onClick={() => removeMember(m.id)}>✕</button>
          </div>
        ))}
        {members.length === 0 && <div style={{ fontSize: 12, color: 'var(--ink-600)', padding: '8px 0' }}>Sin miembros.</div>}
      </div>

      {/* crear RRPP nuevo dentro del grupo */}
      {creating ? (
        <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 8, padding: '12px', background: 'var(--ink-050)', border: '1px solid var(--border)', borderRadius: 4 }}>
          <div className="lb-eyebrow">Invitar a {group.name}</div>
          <p style={{ fontSize: 11, color: 'var(--ink-600)', margin: 0 }}>Le mandamos un email para que complete su registro.</p>
          <input className="lb-input" style={{ padding: '9px 11px', fontSize: 13 }} placeholder="Email de la persona" value={cf.email} onChange={e => setCf({ ...cf, email: e.target.value })} />
          <select className="lb-select" style={{ padding: '9px 28px 9px 11px', fontSize: 13 }} value={cf.role} onChange={e => setCf({ ...cf, role: e.target.value })}>
            <option value="owner">Dueño</option>
            <option value="socio">Socio</option>
            <option value="admin">Administrador</option>
            <option value="rrpp">RRPP</option>
          </select>
          {inviteMsg && <div style={{ fontSize: 11, color: '#2ecc71', wordBreak: 'break-all' }}>{inviteMsg}</div>}
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={invite}>Enviar invitación</button>
            <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => { setCreating(false); setInviteMsg(''); }}>Cancelar</button>
          </div>
        </div>
      ) : adding ? (
        <div style={{ marginTop: 12, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {assignable.map(u => <button key={u.id} className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => addMember(u.id)}>+ {u.full_name || u.name}</button>)}
          {assignable.length === 0 && <div style={{ fontSize: 12, color: 'var(--ink-600)' }}>No hay más usuarios para agregar.</div>}
          <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => setAdding(false)}>Cancelar</button>
        </div>
      ) : (
        <div style={{ marginTop: 12, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={() => setCreating(true)}>+ Invitar</button>
          <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => setAdding(true)}>Agregar existente</button>
        </div>
      )}

      <div style={{ marginTop: 16, paddingTop: 14, borderTop: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={save} disabled={!dirty}>Guardar cambios</button>
        {saved && <span style={{ fontSize: 12, color: '#2ecc71' }}>Guardado ✓</span>}
      </div>
    </div>
  );
}
